export type Mode = "read" | "compose" | null;
export type ChatMessage = { role: "user" | "assistant"; content: string };
export type ActionType = "summarize" | "actionItems" | "replyOptions" | 
                        "custom" | "grammar" | "review" | "professional" | "notes" | "rewrite" | "pivottable";

export interface EmailContent {
  replyOnly: string;
  emailOnly: string;
  hasOriginalEmail: boolean;
}

export const MODEL_OPTIONS = [
  { id: 'gpt-4o-mini', label: '(Public) - GPT-4o Mini' },
  { id: 'deepseek/deepseek-chat-v3-0324', label: '(Private Cloud) - DeepSeek Chat V3' },
  { id: 'deepseek/deepseek-chat-v3.1', label: '(Local) - DeepSeek Chat V3' },
  //{ id: 'openai/gpt-oss-120b', label: 'GPT-OSS 120B' },
] as const;


// ModelId and KnowledgeBaseId are now strings to support dynamic values from API
export type ModelId = string;
export type KnowledgeBaseId = string;